<template>
    <div class="text-center">
        <br>
        <h5>ต้องการเปลี่ยนรายการ PO</h5>
        <br>
        <div class="row form-group">
            <div class="col-4 text-right">เลขที่ใบ PO</div>
            <div class="col-6">
                <input class="form-control" v-model="form.po_number" disabled/>
            </div>
        </div>
        <div class="row text-center">
            <div class="col">
                <b-form-group>
                    <b-form-radio-group
                            v-model="form.status_tax"
                            :options="tax_options"
                    ></b-form-radio-group>
                </b-form-group>
            </div>
        </div>
        <div class="col">
            <button type="button"
                    @click="submitData"
                    class="btn btn-success">
                <icon name="save" style="width: 25px"></icon> บันทึก</button>&nbsp&nbsp
            <button type="button"
                    @click="cancelData"
                    class="btn btn-outline-secondary">
                <icon name="times" style="width: 25px"></icon> ยกเลิก
            </button>
        </div>
    </div>
</template>

<script>
    import { mapState } from "vuex";
    export default {
        name: "change-purchase-tax",
        data(){
            return{
                selected : 1,
                tax_options: [
                    { value: 0, text: 'ไม่มีภาษี' },
                    { value: 1, text: 'มีภาษี' },
                ],
            }
        },
        computed:{
            ...mapState({
                form : state=>{
                    return state.PurchaseOrder.form;
                },
            })
        },
        methods:{
            submitData(){
                this.$store.dispatch("PurchaseOrder/update",{
                    id : this.form.id,
                    data : this.form,
                }).then(()=>{
                    this.$emit("submit",1)
                })
            },
            cancelData(){
                this.$emit("submit",0)
            }
        }
    }
</script>

<style scoped>

</style>